import { z } from "zod";
import { publicEndpoint } from "~/lib/api/builder";

export const resetPassword = publicEndpoint.mutation(
    (json) => ({
        json,
        method: "POST",
        url: "auth/reset-password",
    }),
    {
        input: z.object({
            email: z.string(),
            password: z.string(),
            password_confirmation: z.string(),
            token: z.string(),
        }),
        output: z.object({}),
    },
);
